enum UnleashPermissions {
  NewScheduleButtons = 'iclinic-frontend.schedule.iclinic-assist-schedule',
  GlicFlag = 'carecare.glic.enabled',
  CheckoutV2Routes = 'iclinic-frontend.checkout.v2_routes',
}

export default UnleashPermissions;
